<ng-container [ngSwitch]="typeSwitch">
  <input *ngSwitchCase="'number'" class="form-control" type="number" [class]="customClass" [name]="name"
    [(ngModel)]="model" (ngModelChange)="modelChange.emit($event)" (change)="valueChanged()" (keyup.enter)="onEnter()"
    (blur)="onBlur()" [required]="required" [disabled]="disabled" [step]="step" [tabindex]="tabIndex" />

  <input *ngSwitchCase="'bool'" class="form-control my-checkbox" type="checkbox" [class]="customClass" [name]="name"
    [(ngModel)]="model" (ngModelChange)="modelChange.emit($event)" (change)="valueChanged()" (keyup.enter)="onEnter()"
    (blur)="onBlur()" [required]="required" [disabled]="disabled" />

  <s-input-date *ngSwitchCase="'date'" [type]="type" [class]="customClass" [name]="name" (change)="valueChanged()"
    (enter)="onEnter()" (blur)="onBlur()" [(model)]="model" [required]="required" [disabled]="disabled"
    [alertHoliday]="alertHoliday" [minW]="minW" [tabindex]="tabIndex"></s-input-date>

  <s-select *ngSwitchCase="'select'" [customClass]="customClass" [name]="name" (change)="valueChanged()"
    (blur)="onBlur()" [(model)]="model" [items]="items" [bindValue]="bindValue" [bindLabel]="bindLabel"
    [placeholder]="placeholder" [appendTo]="appendTo" [dropdownPosition]="dropdownPosition" [addTag]="addTag"
    [loading]="loading" [multiple]="multiple" [clearable]="clearable" [searchFn]="searchFn"
    [translateAppendix]="translateAppendix" [customOption]="customOption" [customLabel]="customLabel"
    [required]="required" [disabled]="disabled" [minW]="minW" [tabindex]="tabIndex">
  </s-select>

  <ui-switch *ngSwitchCase="'switch'" [class]="customClass" [name]="name" [(ngModel)]="model" [size]="size"
    (change)="valueChanged()" (ngModelChange)="modelChange.emit($event)" [color]="color" [switchOffColor]="colorOff"
    defaultBoColor="darkgrey" [disabled]="disabled">
  </ui-switch>

  <textarea *ngSwitchCase="'textarea'" class="form-control" [class]="customClass" [name]="name" [(ngModel)]="model"
    (ngModelChange)="modelChange.emit($event)" (change)="valueChanged()" (keyup.enter)="onEnter()" (blur)="onBlur()"
    rows="2" style="resize:  vertical" [required]="required" [disabled]="disabled" [tabindex]="tabIndex"></textarea>

  <input *ngSwitchDefault class="form-control" type="text" [class]="customClass" [name]="name" [(ngModel)]="model"
    (ngModelChange)="modelChange.emit($event)" (change)="valueChanged()" (keyup.enter)="onEnter()" (blur)="onBlur()"
    [required]="required" [disabled]="disabled" [placeholder]="placeholder |translate" [tabindex]="tabIndex" />
</ng-container>
